import React from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useRouter } from 'next/router';

// utils
import { generateMeta, getMetaImage } from '../../utils/meta';
import getCmsCanonicalUrl from '../../utils/getCmsCanonicalUrl';

const LeScoopMeta = (props) => {
  const router = useRouter() ?? {};
  // TODO: refactor similar logic in /index and /[cms] to use this

  return (
    <Head>
      {
          Object.entries(props.page).length > 0 && generateMeta({
            key: 'cms',
            title: props.page.meta_data?.title,
            description: props.page.meta_data?.description,
            og: {
              description: props.page.meta_data?.description,
              image: getMetaImage(props),
              title: props.page.meta_data?.title,
              url: `${process.env.NEXT_PUBLIC_CLIENT_HOST}${router.asPath}`
            },
            twitter: {
              description: props.page.meta_data?.description,
              image: getMetaImage(props),
              title: props.page.meta_data?.title
            }
          })
        }
      {
        Object.keys(router)?.length > 0 && (
          <link
            key="canonical"
            rel="canonical"
            href={getCmsCanonicalUrl(router)}
          />
        )
      }
      <title>{props.page.meta_data?.title}</title>
      <meta name="description" content={props.page.meta_data?.description} />
    </Head>
  );
};

LeScoopMeta.propTypes = {
  page: PropTypes.object.isRequired
};

export default LeScoopMeta;
